import { Button } from "reactstrap"

const ToggleButton = ({
  active,
  children,
  color = "success",
  inactiveColor = "light",
  disabled = false,
  onClick,
}) => (
  <Button
    type="button"
    size="sm"
    color={active ? color : inactiveColor}
    outline={!active}
    disabled={disabled}
    onClick={onClick}
  >
    {children}
  </Button>
)

export default ToggleButton
